// extracted by mini-css-extract-plugin
export default {"contacto":"Contacto_contacto__Q-buW"};